module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_26_E_2.0b8bfc0e.mp3";